import { InitialisationConfig } from "@/core/utils/getInitialisationConfig";
import { getBasicConfig } from "@/core/utils";
import { createContext, ReactNode } from "react";

const DEFAULT_CONFIG: InitialisationConfig = getBasicConfig({});

export const ConfigContext =
  createContext<InitialisationConfig>(DEFAULT_CONFIG);

interface ConfigProviderProps {
  children: ReactNode;
  config: InitialisationConfig;
}

export const ConfigProvider = ({ children, config }: ConfigProviderProps) => {
  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};
